import css from './ViewReport.module.css';

import {
  Alignment,
  DataStatus,
  Display,
  Spacing,
  StatusUtil,
} from '../../../types/appTypes';
import StatusText from '../../Common/StatusText/StatusText';
import Spinner from '../../Common/Spinner/Spinner';
import { useEffect, useState } from 'react';
import Container from '../../Common/Container/Container';
import Card from '../../Common/Card/Card';
import { useReportParams } from '../../../hooks/useReportParams';
import { FaExclamationTriangle } from 'react-icons/fa';

type ViewReportProps = {
  reportPath: string | undefined;
  encryptedReportParams?: string;
  overlayClassOverride?: string;
  onEmbedError: () => void;
};

const ViewReport = ({
  reportPath,
  encryptedReportParams,
  overlayClassOverride,
  onEmbedError,
}: ViewReportProps) => {
  const [embedError, setEmbedError] = useState(undefined);
  const { status: paramsStatus, decryptedParams } = useReportParams({
    encryptedParams: encryptedReportParams,
  });

  useEffect(() => {
    if (
      embedError === undefined &&
      reportPath !== undefined &&
      reportPath !== '' &&
      (encryptedReportParams === undefined || decryptedParams !== undefined)
    ) {
      window
        .embedSpotfire(
          process.env.REACT_APP_SPOTFIRE_CONTAINER!,
          process.env.REACT_APP_SPOTFIRE_OVERLAY!,
          process.env.REACT_APP_SPOTFIRE_STATUS!,
          process.env.REACT_APP_SPOTFIRE_CLIENT_ID!,
          process.env.REACT_APP_SPOTFIRE_REDIRECT_URI!,
          process.env.REACT_APP_SPOTFIRE_ROOT!,
          reportPath!,
          decryptedParams
        )
        .then((err: any) => {
          if (embedError !== err) {
            setEmbedError(err);
            onEmbedError();
          }
        });
    }
  }, [reportPath, encryptedReportParams, decryptedParams, embedError, onEmbedError]);

  if (reportPath === undefined || reportPath === '') {
    return <></>;
  }

  if (paramsStatus === DataStatus.Loading) {
    return (
      <Card flexDirection='column'>
        <Container alignment={Alignment.Center}>
          <Spinner />
        </Container>
      </Card>
    );
  }

  if (StatusUtil.isFail(paramsStatus) || embedError !== undefined) {
    return (
      <Card flexDirection='column'>
        <Container alignment={Alignment.Center}>
          <StatusText
            text='An error occurred and the report could not be loaded.'
            error={true}
            icon={<FaExclamationTriangle />}
          />
        </Container>
      </Card>
    );
  }

  const overlayClass =
    overlayClassOverride === undefined
      ? css.reportOverlay
      : overlayClassOverride;

  return (
    <>
      <div
        id={process.env.REACT_APP_SPOTFIRE_CONTAINER!}
        className={css.reportRoot}
      ></div>
      <div
        id={process.env.REACT_APP_SPOTFIRE_OVERLAY!}
        className={overlayClass}
      >
        <Card flexDirection='column'>
          <Container alignment={Alignment.Center}>
            <Container
              display={Display.Block}
              padding={[
                Spacing.None,
                Spacing.None,
                Spacing.Medium,
                Spacing.None,
              ]}
            >
              <StatusText
                text='Please wait while Atlas is authenticating...'
                id={process.env.REACT_APP_SPOTFIRE_STATUS}
                error={false}
              />
            </Container>
            <Spinner />
          </Container>
        </Card>
      </div>
    </>
  );
};

export default ViewReport;
